import { ONBOARDING_BASE_PATH } from '@/constants/onboarding';
import { StaffUserSession } from '@/types/staffSession';

export const getToken = (host: string): string | unknown => {
  // if in onboarding context, return
  // prevents passing expired dugout current user tokens
  if (window.location.pathname.startsWith(ONBOARDING_BASE_PATH)) {
    return undefined;
  }

  try {
    const currentUserByHostJson = localStorage.getItem('dugoutCurrentUser');

    if (!currentUserByHostJson) {
      return;
    }

    const currentUserByHost: { [key: string]: StaffUserSession } =
      JSON.parse(currentUserByHostJson);
    const currentUser = currentUserByHost[host];

    const authToken = currentUser?.api_key;

    if (authToken != null) {
      return authToken;
    }
  } catch {
    throw new Error('Unable to get access token');
  }
};
